import React from "react";
import dynamic from "next/dynamic";
import Image from "@/bit/components/components.c-image";

import style from "./style";
const Icon = dynamic(() => import("@/bit/components/components.icon-glyph"));

/**
 * Alert component
 * @param {string} props.iconType - The type of the icon
 * @param {string} props.srcImage - The source image URL
 * @param {object} props.textProps - The props for the Text component
 * @returns {React.ReactNode} The rendered Alert component
 */
const Alert = ({ hash="", icon, srcImage, children, className = "" }) => {

  if (
    (!icon && !srcImage) ||
    (!children)
  ) {
    return null;
  }

  return (
    <div className={`alert ${className}`}>
      {icon && icon.name && (
        <div className={`icon-container`}>
          <div className={`icon ${icon.withBackground ? 'background' : ''}`}>
            <Icon id={icon.name} height={icon.height || 20} color={icon.color} />
          </div>
        </div>
      )}

      {srcImage && (
        <div className="image">
          <Image
            hash={hash}
            src={srcImage}
            alt="image-alert"
            objectFit="cover"
            width={20}
            height={20}
          />
        </div>
      )}
      {children}
      <style jsx>{style}</style>
    </div>
  );
};

export default Alert;
